/**
 * @generated SignedSource<<bf389c2301ddf6f6c23f322bf48ab269>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobApplicationDialog_Query$variables = {
  firmSlug: string;
  jobSlug: string;
};
export type JobApplicationDialog_Query$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"JobApplicationDialog_User">;
  } | null | undefined;
  readonly job: {
    readonly " $fragmentSpreads": FragmentRefs<"JobApplicationDialog_Job">;
  } | null | undefined;
};
export type JobApplicationDialog_Query = {
  response: JobApplicationDialog_Query$data;
  variables: JobApplicationDialog_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "firmSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jobSlug"
},
v2 = [
  {
    "kind": "Variable",
    "name": "firmSlug",
    "variableName": "firmSlug"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "jobSlug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileJobIncompatibilityReasons",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "freelancerRate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Currency",
  "kind": "LinkedField",
  "name": "currency",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rateMode",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  (v11/*: any*/),
  (v4/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Industry",
  "kind": "LinkedField",
  "name": "industry",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupIndex",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobApplicationDialog_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Job",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "JobApplicationDialog_Job"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "JobApplicationDialog_User"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "JobApplicationDialog_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Job",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Firm",
            "kind": "LinkedField",
            "name": "firm",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Contract",
                "kind": "LinkedField",
                "name": "contract",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobApplication",
            "kind": "LinkedField",
            "name": "jobApplication",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileWillUpdateOnApply",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileCompatibleWithJob",
                "storageKey": null
              },
              (v4/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Job",
                "kind": "LinkedField",
                "name": "job",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobApplication",
                    "kind": "LinkedField",
                    "name": "jobApplication",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Firm",
                    "kind": "LinkedField",
                    "name": "firm",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "locationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Country",
                    "kind": "LinkedField",
                    "name": "jobCountries",
                    "plural": true,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezoneIdentifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezoneRange",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobsSpecialization",
                    "kind": "LinkedField",
                    "name": "jobsSpecializations",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Specialization",
                        "kind": "LinkedField",
                        "name": "specialization",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rawId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "positionTypes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobSkill",
                    "kind": "LinkedField",
                    "name": "jobSkills",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "required",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "requiredYears",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Skill",
                        "kind": "LinkedField",
                        "name": "skill",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requiredExperienceYears",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workingOrOfferedJob",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "guest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v4/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobTypes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Specialization",
                "kind": "LinkedField",
                "name": "specializations",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalExperience",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timezoneName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserSkill",
            "kind": "LinkedField",
            "name": "userSkills",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experience",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Skill",
                "kind": "LinkedField",
                "name": "skill",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMember",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClient",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e04c0da651098e40f38a4e564efeefa0",
    "id": null,
    "metadata": {},
    "name": "JobApplicationDialog_Query",
    "operationKind": "query",
    "text": "query JobApplicationDialog_Query(\n  $jobSlug: String!\n  $firmSlug: String!\n) {\n  job(slug: $jobSlug, firmSlug: $firmSlug) {\n    ...JobApplicationDialog_Job\n    id\n  }\n  currentUser {\n    ...JobApplicationDialog_User\n    id\n  }\n}\n\nfragment CompensationConfirmation_Job on Job {\n  rateMode\n  freelancerRate {\n    value\n  }\n  currency {\n    code\n    id\n  }\n  jobApplication {\n    profileJobIncompatibilityReasons\n    id\n  }\n}\n\nfragment CompensationConfirmation_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...CompensationConfirmation_Job\n    id\n  }\n}\n\nfragment CompensationConfirmation_User on User {\n  profile {\n    freelancerRate {\n      value\n    }\n    currency {\n      code\n      id\n    }\n    rateMode\n    id\n  }\n}\n\nfragment IndustryMismatch_Job on Job {\n  industry {\n    name\n    id\n  }\n}\n\nfragment IndustryMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...IndustryMismatch_Job\n    id\n  }\n}\n\nfragment IndustryMismatch_User on User {\n  profile {\n    industry {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment JobApplicationDialog_Job on Job {\n  ...useJobApplication_Job\n  ...JobSpecConfirmationDialog_Job\n}\n\nfragment JobApplicationDialog_User on User {\n  ...useJobApplication_User\n  ...JobSpecConfirmationDialog_User\n  ...user_useIsMember\n  ...user_useIsClient\n}\n\nfragment JobSpecConfirmationDialog_Job on Job {\n  slug\n  firm {\n    slug\n    id\n  }\n  jobApplication {\n    ...JobSpecConfirmationDialog_JobApplication\n    id\n  }\n  ...job_useApplyToJob\n}\n\nfragment JobSpecConfirmationDialog_JobApplication on JobApplication {\n  status\n  profileCompatibleWithJob\n  profileWillUpdateOnApply\n  ...RateConfirmation_JobApplication\n  ...CompensationConfirmation_JobApplication\n  ...ResumeMismatch_JobApplication\n  ...IndustryMismatch_JobApplication\n  ...LocationMismatch_JobApplication\n  ...SubtypesMismatch_JobApplication\n  ...PositionTypeMismatch_JobApplication\n  ...SkillMismatch_JobApplication\n  ...TotalExperienceMismatch_JobApplication\n}\n\nfragment JobSpecConfirmationDialog_User on User {\n  ...IndustryMismatch_User\n  ...CompensationConfirmation_User\n  ...LocationMismatch_User\n  ...PositionTypeMismatch_User\n  ...RateConfirmation_User\n  ...SkillMismatch_User\n  ...SubtypesMismatch_User\n  ...TotalExperienceMismatch_User\n}\n\nfragment LocationMismatch_Job on Job {\n  slug\n  firm {\n    slug\n    id\n  }\n  locationType\n  jobCountries {\n    name\n    id\n  }\n  timezoneIdentifier\n  timezoneRange\n}\n\nfragment LocationMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...LocationMismatch_Job\n    id\n  }\n}\n\nfragment LocationMismatch_User on User {\n  profile {\n    country {\n      name\n      id\n    }\n    id\n  }\n  timezoneName\n}\n\nfragment PositionTypeMismatch_Job on Job {\n  positionTypes\n  jobApplication {\n    profileJobIncompatibilityReasons\n    id\n  }\n}\n\nfragment PositionTypeMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...PositionTypeMismatch_Job\n    id\n  }\n}\n\nfragment PositionTypeMismatch_User on User {\n  profile {\n    jobTypes\n    id\n  }\n}\n\nfragment RateConfirmation_Job on Job {\n  freelancerRate {\n    value\n  }\n  currency {\n    code\n    id\n  }\n  rateMode\n}\n\nfragment RateConfirmation_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...RateConfirmation_Job\n    id\n  }\n}\n\nfragment RateConfirmation_User on User {\n  profile {\n    freelancerRate {\n      value\n    }\n    rateMode\n    currency {\n      code\n      id\n    }\n    id\n  }\n}\n\nfragment ResumeMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    slug\n    firm {\n      slug\n      id\n    }\n    id\n  }\n}\n\nfragment SkillMismatch_Job on Job {\n  ...job_useMismatchingSkillsJob\n}\n\nfragment SkillMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...SkillMismatch_Job\n    id\n  }\n}\n\nfragment SkillMismatch_User on User {\n  ...job_useMismatchingSkillsUser\n}\n\nfragment SubtypesMismatch_Job on Job {\n  jobsSpecializations {\n    specialization {\n      name\n      id\n    }\n    id\n  }\n  ...job_useMissingSubtypesJob\n}\n\nfragment SubtypesMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...SubtypesMismatch_Job\n    id\n  }\n}\n\nfragment SubtypesMismatch_User on User {\n  ...job_useMissingSubtypesUser\n}\n\nfragment TotalExperienceMismatch_Job on Job {\n  requiredExperienceYears\n  jobApplication {\n    profileJobIncompatibilityReasons\n    id\n  }\n}\n\nfragment TotalExperienceMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...TotalExperienceMismatch_Job\n    id\n  }\n}\n\nfragment TotalExperienceMismatch_User on User {\n  profile {\n    totalExperience\n    id\n  }\n}\n\nfragment job_useApplyToJob on Job {\n  id\n  firm {\n    contract {\n      id\n    }\n    id\n  }\n}\n\nfragment job_useMismatchingSkillsJob on Job {\n  jobSkills {\n    required\n    requiredYears\n    groupIndex\n    skill {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment job_useMismatchingSkillsUser on User {\n  userSkills {\n    experience\n    skill {\n      id\n    }\n    id\n  }\n}\n\nfragment job_useMissingSubtypesJob on Job {\n  jobsSpecializations {\n    groupIndex\n    specialization {\n      id\n      rawId\n      name\n    }\n    id\n  }\n}\n\nfragment job_useMissingSubtypesUser on User {\n  profile {\n    specializations {\n      id\n    }\n    id\n  }\n}\n\nfragment useJobApplication_Job on Job {\n  slug\n  firm {\n    slug\n    id\n  }\n  jobApplication {\n    ...useJobApplication_JobApplication\n    id\n  }\n  ...job_useApplyToJob\n}\n\nfragment useJobApplication_JobApplication on JobApplication {\n  profileWillUpdateOnApply\n  profileCompatibleWithJob\n}\n\nfragment useJobApplication_User on User {\n  status\n  workingOrOfferedJob\n  ...user_useIsGuest\n}\n\nfragment user_isClient on User {\n  status\n  isClient\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_isMember on User {\n  status\n  isMember\n}\n\nfragment user_useIsClient on User {\n  ...user_isClient\n}\n\nfragment user_useIsGuest on User {\n  ...user_isGuest\n}\n\nfragment user_useIsMember on User {\n  ...user_isMember\n}\n"
  }
};
})();

(node as any).hash = "09fe75d0daff5c93895c166663e7b69a";

export default node;
